<template>
  <div class="pagetdetial" v-if="addshow">
    <md-field class="other">
      <md-cell-item title="訂單號" no-border @click.stop="copy(par.code)">
        <span class="holder" slot="right">{{ par.code }}
          <img src="@/assets/image/copy.png" alt="" style="margin-left: 0.2rem"/></span>
      </md-cell-item>
      <md-cell-item title="狀態" no-border>
        <span class="holder" slot="right" v-if="par.status == 1" style="color: #e51c23">待付款</span>
        <span class="holder" slot="right" v-if="par.status == 2" style="color: #e51c23">待收貨</span>
        <span class="holder" slot="right" v-if="par.status == 3" style="color: #e51c23">已完成</span>
        <span class="holder" slot="right" v-if="par.status == 4" style="color: #e51c23">已取消</span>
        <span class="holder" slot="right" v-if="par.status == 5" style="color: #e51c23">退款中</span>
        <span class="holder" slot="right" v-if="par.status == 6" style="color: #e51c23">支付待确认</span>
        <span class="holder" slot="right" v-if="par.status == 7" style="color: #e51c23">支付失败</span>
        <span class="holder" slot="right" v-if="par.status == 10" style="color: #888888">打包中</span>
        <span class="holder" slot="right" v-if="par.status == 11" style="color: orangered">打包完成</span>
      </md-cell-item>
      <md-cell-item title="發貨倉" no-border>
        <span class="holder" slot="right">{{ par.warehouse }}</span>
      </md-cell-item>

      <md-cell-item title="订单备注" no-border v-if="par.remark">
        <span class="holder" slot="right">{{ par.remark }}</span>
      </md-cell-item>
      <md-cell-item title="失败原因" no-border v-if="par.status == 7">
        <span class="holder" slot="right">{{ par.auditMemo }}</span>
      </md-cell-item>
      <md-cell-item title="配送單號" no-border v-if="par.trackingNumber"
                    @click.stop="par.trackingNumber ? copy(par.code) : ''">
        <span class="holder" slot="right">{{
            par.trackingNumber
          }}<img v-if="par.trackingNumber" src="@/assets/image/copy.png" alt=""
                 style="margin-left: 0.2rem"/></span>
      </md-cell-item>
      <md-cell-item title="代收貨款" v-if="par.replacePrice > 0" no-border>
        <md-amount :value="par.replacePrice" has-separator class="holder" slot="right"></md-amount>
      </md-cell-item>
      <md-cell-item title="線路" v-if="par.channelVo" no-border>
        <span class="holder" slot="right">{{
            par.channelVo.transCode
          }}</span>
      </md-cell-item>
      <md-cell-item title="下單時間" no-border>
        <span class="holder" slot="right">{{
            par.createTime | dateformat("YYYY-MM-DD HH:mm")
          }}</span>
      </md-cell-item>
      <md-cell-item title="打包时间" no-border v-if="par.afootInfo">
        <span class="holder" slot="right">{{
            par.afootInfo.createTime | dateformat("YYYY-MM-DD HH:mm")
          }}</span>
      </md-cell-item>
      <md-cell-item title="支付方式" v-if="par.orderPay" no-border>
        <span class="holder" slot="right" v-if="par.orderPay.payType == 0">余额支付</span>
        <span class="holder" slot="right" v-if="par.orderPay.payType == 1">微信支付</span>
        <span class="holder" slot="right" v-if="par.orderPay.payType == 2">支付寶支付</span>
        <span class="holder" slot="right" v-if="par.orderPay.payType == 3">綠界支付</span>
        <span class="holder" slot="right" v-if="par.orderPay.payType == 4">paypal</span>
        <span class="holder" slot="right" v-if="par.orderPay.payType == 5">淘宝店铺支付</span>
      </md-cell-item>
      <md-cell-item title="报关需求" v-if="par.customsDeclarationDemand">
        <span class="holder" slot="right">{{ par.customsDeclarationDemand }}</span>
      </md-cell-item>
      <md-cell-item title="支付时间" v-if="par.orderPay" no-border>
        <span class="holder" slot="right">{{
            par.updateTime | dateformat("YYYY-MM-DD HH:mm")
          }}</span>
      </md-cell-item>

    </md-field>
    <md-field class="other" style="margin-top: 0.3rem;padding:0.3rem" v-if="par.userAddress">
      <md-cell-item class="address" no-border
                    :title="par.userAddress.name + ' , ' + par.userAddress.mobile"
                    :brief="par.userAddress.concatAddress">
        <div slot="left"
             style="display: flex;flex-direction:column;align-items: center;justify-content: space-around">
          <md-tag size="large" shape="fillet" type="fill" fill-color="#2f86f6" font-weight="normal"
                  font-color="#ffffff" v-if="par.userAddress.isSuperMall == 0">宅配
          </md-tag>
          <md-tag size="large" shape="fillet" type="fill" style="margin-top: -0.1rem"
                  fill-color="#2f86f6" font-weight="normal" font-color="#ffffff" v-else>店配
          </md-tag>
          <md-tag size="large" shape="fillet" type="fill" fill-color="#eeeeee" font-weight="normal"
                  font-color="#000000" style="margin-top: 0.1rem" v-if="par.userAddress.isSuperMall != 0">
            <span v-if="par.userAddress.mallBrand == 1">全家</span>
            <span v-if="par.userAddress.mallBrand == 2">711</span>
          </md-tag>
        </div>
      </md-cell-item>
      <md-cell-item class="address" v-if="par.userAddress && !par.userAddress.concatAddress"
                    :title="par.userAddress.name + ' , ' + par.userAddress.mobile"
                    :brief="par.userAddress.concatAddress">
        <div slot="left"
             style="display: flex;flex-direction:column;align-items: center;justify-content: space-around">
          <md-tag size="large" shape="fillet" type="fill" fill-color="#2f86f6" font-weight="normal"
                  font-color="#ffffff" v-if="par.userAddress.isSuperMall == 0">宅配
          </md-tag>
          <md-tag size="large" shape="fillet" type="fill" style="margin-top: -0.1rem"
                  fill-color="#2f86f6" font-weight="normal" font-color="#ffffff" v-else>店配
          </md-tag>
          <md-tag size="large" shape="fillet" type="fill" fill-color="#eeeeee" font-weight="normal"
                  font-color="#000000" style="margin-top: 0.1rem" v-if="par.userAddress.isSuperMall != 0">
            <span v-if="par.userAddress.mallBrand == 1">全家</span>
            <span v-if="par.userAddress.mallBrand == 2">711</span>
          </md-tag>
        </div>
      </md-cell-item>
    </md-field>
    <div>
      <div class="packtitle" @click="showckal('bottom')">
        <span>包裹明細</span>
        <span style="color: #2a78dc">查看全部商品</span>
      </div>
      <div class="packcontilist">
        <div class="listmkck">
          <div class="listpack">
            <div class="packnumber" style="margin-left: 0.4rem">
              <span>包裹單號</span>
            </div>
            <div class="packtype">
              <span>類型</span>
            </div>
            <div class="packweight">
              <span>实重</span>
            </div>
            <div class="packvalue">
              <span>计费重</span>
            </div>
          </div>
          <div class="listpack" v-for="(item, index) in par.parcelList" :key="index">
            <div class="packnumber" style="margin-left: 0.4rem">
              <span>{{ item.expressNumber }}</span>
            </div>
            <div class="packtype">
              <span v-if="item.type == 1" style="color: orangered">特貨</span>
              <span v-else>普貨</span>
            </div>
            <div class="packweight">
              <span>{{ item.realWeight }}KG</span>
            </div>
            <div class="packvalue">
              <span>{{ item.bulk }}KG</span>
            </div>
          </div>
        </div>
        <div class="listpack">
          <div class="packnumber" style="margin-left: 0.4rem">
            <span>合计</span>
          </div>
          <div class="packtype">

          </div>
          <div class="packweight">
            <span style="color: #333333;font-weight: bolder">{{ par.realWeight }}KG</span>
          </div>
          <div class="packvalue">
            <span style="color: #333333;font-weight: bolder">{{ par.bulk }}KG</span>
          </div>
        </div>
        <p style="margin-top: 0.2rem;padding-left: 0.4rem;font-size: 0.3rem;text-align: left">
        <span>申报總值：<md-amount :value="par.productPrice" has-separator></md-amount>
          <span>CNY</span></span>
        </p>
      </div>

    </div>
    <div v-if="par.afootInfo&&par.chargeMode===2">
      <div class="packtitle" @click="showckal('bottom')">
        <span>打包信息</span>
      </div>
      <div class="packcontilist">
        <div class="listmkck">
          <div class="listpack">
            <div class="packnumber" style="margin-left: 0.3rem">
              <span>打包單號</span>
            </div>
            <div class="packtype">
              <span>实重</span>
            </div>
            <div class="packweight">
              <span>计费重</span>
            </div>
            <div class="packvalue">
              <span>打包尺寸</span>
            </div>
          </div>
          <div class="listpack" v-for="(item, index) in par.afootInfo.packages" :key="index">
            <div class="packnumber" style="margin-left: 0.3rem; overflow: hidden">
              <span>{{ item.baleNo }}</span>
            </div>
            <div class="packtype">
              <span>{{ item.weight }}KG</span>
            </div>
            <div class="packweight">
              <span style="color: orangered">{{ item.cweight }}KG</span>
            </div>
            <div class="packvalue">
              <span>{{ item.length }} x {{ item.width }} x {{ item.height }}</span>
            </div>
          </div>
        </div>
        <div class="listpack">
          <div class="packnumber" style="margin-left: 0.3rem">
            <span>合计</span>
          </div>
          <div class="packtype">
            <span style="color: #333333;font-weight: bolder">{{ getsum('weight', par.afootInfo.packages) }}KG</span>
          </div>
          <div class="packweight">
            <span style="color: #333333;font-weight: bolder">{{ getsum('cweight', par.afootInfo.packages) }}KG</span>
          </div>
          <div class="packvalue">

          </div>
        </div>
        <div v-if="par.afootInfo&&par.afootInfo.imageUrl" style="width: 100%;height: 2rem">
          <ul style="display: flex;flex-wrap: nowrap;overflow-x: scroll;width: 100%;height: 2rem">
            <template v-for="(item, index) in par.afootInfo.imageUrl">
              <li @click="showViewer(index, $event)" :key="index"
                  style="width: 3rem;height: 2rem;margin-right: 10px;margin-left: 4%">
                <img :src="item.image" alt="" style="height: 2rem;margin-right: 10px;width: auto">
              </li>
            </template>
          </ul>
        </div>
        <!--        <p style="margin-top: 0.2rem;padding-left: 0.15rem;height: 0.5rem; font-size: 0.26rem;text-align: center;background-color: yellow;width: 92%;margin-left: 4%">-->
        <!--        <span style="color: orangered;line-height: 0.5rem"> 打包后付款订单按实际打包后计费重计算运费 </span>-->
        <!--        </p>-->
      </div>

    </div>

    <div v-if="declarantList.length > 0">
      <div class="packtitle">
        <span>申報人</span>
      </div>
      <div class="declared_container">
        <div style="width: 95%">
          <table border="0">
            <tr class="header">
              <th>姓名</th>
              <th>聯系電話</th>
              <th>證件號</th>
            </tr>
            <tr v-for="(item, index) in declarantList" :key="index" class="content">
              <td>{{ item.name }}</td>
              <td>{{ item.mobile }}</td>
              <td>{{ item.certificateNo }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div v-if="par.status<10">
      <md-field style="margin-top: 0.3rem" class="noth">
        <div v-if="par.chargeMode===1">
          <md-cell-item title="基础运费" :brief="'+¥' + par.freight"/>
          <md-cell-item v-if="par.timeOutPrice > 0" title="超期費" :brief="'+¥' + par.timeOutPrice"/>
          <!-- <md-cell-item v-if="par.parcelTotalSurchargesMoney > 0" title="附加费"
            @click="showCustomTransition = true" :brief="'+¥' + par.parcelTotalSurchargesMoney" /> -->
          <div v-for="(item,index) in par.addedList" :key="index">
            <md-cell-item :title="item.name" :brief="'+¥' + item.addedPrice"/>
          </div>
          <div v-if="par.orderSurchargeInfo.totalSurcharge>0">
            <md-cell-item :title="item.surchargeName" :brief="'+¥' + item.money"
                          v-for="(item,index) in par.orderSurchargeInfo.triggerSurchargeList" :key="index"/>
          </div>
          <md-cell-item v-if="par.isGoodsTax == 1" :title="par.taxName" :brief="'+¥' + par.rat"/>
          <md-cell-item v-if="par.couponPrice > 0" title="优惠金额" :brief="'-¥' + par.couponPrice"
                        style="color: #32c5ea"/>
          <md-cell-item v-if="par.freightDiscountMoney > 0" title="等级折抵" :brief="'-¥' + par.freightDiscountMoney"
                        style="color: #32c5ea"/>
          <md-cell-item v-if="par.protectionPrice > 0" title="保價" :brief="'+¥' + par.protectionPrice"/>
          <md-cell-item v-if="par.creditPrice > 0" title="积分抵扣" :brief="'-¥' + par.creditPrice"
                        no-border style="color: #32c5ea"/>
        </div>
        <div v-if="par.chargeMode===2">
          <md-cell-item title="基础运费" :brief="'+¥' + par.freight"/>
          <div v-if="par.afootInfo">
            <div v-for="(item,index) in par.afootInfo.servicecharge" :key="index">
              <md-cell-item :title="item.name" :brief="'+¥' + item.money"/>
            </div>
          </div>
          <div v-if="par.status===10">
            <md-cell-item no-border v-for="(item,index) in par.addedList" :key="index" :title="item.name">
              <span class="holder" slot="right">{{ item.addedPrice }} CNY</span>
            </md-cell-item>
          </div>
          <md-cell-item v-if="par.couponPrice > 0" title="优惠金额" :brief="'-¥' + par.couponPrice"
                        style="color: #32c5ea"/>
          <md-cell-item v-if="par.creditPrice > 0" title="积分抵扣" :brief="'-¥' + par.creditPrice"
                        no-border style="color: #32c5ea"/>
        </div>
      </md-field>
      <div style="width: 100%;height: 1.2rem"></div>
      <div class="bootomsubmit" v-if="par.status < 2">
        <p v-if="par.status == 1">
          合计：<span>{{ par.totalPrice }} CNY</span>
        </p>
        <p v-if="par.status == 3">
          實付款：<span>￥ {{ par.totalPrice }}</span>
        </p>
        <md-button v-if="par.status == 1" :type="par.totalPrice > 0 ? 'warning' : 'disabled'"
                   :loading="loading"  inline @click="submit">提交
        </md-button>
      </div>
      <div class="bootomsubmit" v-if="par.status == 2 || par.status == 3">
        <p>
          實付款：
          <md-amount :value="par.totalPrice" has-separator style="font-size:0.4rem"></md-amount>
          CNY
        </p>
      </div>
    </div>
    <div v-if="par.status===11">
      <md-field style="margin-top: 0.3rem" class="noth">
        <md-cell-item title="基础运费" :brief="'+¥' + par.freight" v-if="par.status!=10"/>
        <div v-if="par.afootInfo">
          <div v-for="(item,index) in par.afootInfo.servicecharge" :key="index">
            <md-cell-item :title="item.name" :brief="'+¥' + item.money"/>
          </div>
        </div>
        <md-cell-item v-if="par.couponPrice > 0" title="优惠金额" :brief="'-¥' + par.couponPrice"/>
        <md-cell-item v-if="par.creditPrice > 0" title="积分抵扣" :brief="'-¥' + par.creditPrice"
                      no-border/>
      </md-field>
      <md-field style="margin-top: 0.3rem" class="noright" v-if="par.status===11">
        <md-cell-item title="優惠券" :brief="counp" @click="getcouefrt">
          <div slot="right" style="width: 0.8rem">
            <img src="@/assets/image/icon_dropdown.png" alt="" style="width: 0.5rem"/>
          </div>
          <div slot="children" style="font-size: 0.32rem; color: #e51c23; text-align: left">
            增值服務和稅收產生的費用不在優惠範圍內
          </div>
        </md-cell-item>
        <md-cell-item title="积分抵扣" v-if="Number(creditPrice) > 0&&par.status===11">
          <span style="color: #e51c23;font-size: 0.22rem">可抵扣{{ creditPrice }}CNY(消耗{{ creditValue }}积分)</span>
          <md-switch v-model="creditStatus" @change="changeAllPrice"></md-switch>
        </md-cell-item>
      </md-field>
      <div style="width: 100%;height: 1.2rem"></div>
      <div class="bootomsubmit" v-if="par.status ===11">
        <p>
          应付总额：<span>{{ allTotalprice }} CNY</span>
        </p>

        <md-button :type="allTotalprice > 0 ? 'warning' : 'disabled'"
                   :loading="loading" inline @click="submitPrice" v-if="par.status===11">确认并付款
        </md-button>
      </div>
      <div class="bootomsubmit" v-if="par.status == 2 || par.status == 3">
        <p>
          實付款：
          <md-amount :value="par.totalPrice" has-separator style="font-size:0.4rem"></md-amount>
          CNY
        </p>
      </div>
    </div>

    <md-popup v-model="showpup.bottom" position="bottom">
      <div class="packlist">
        <div
          style="width: 100%;height:0.8rem;display: flex;align-items: center;justify-content: center;font-size: 0.3rem">
          <span>訂單內全部商品</span>
        </div>
        <div class="borerconew">
          <div class="listmkck" style="border: none">
            <div class="listpack">
              <div class="packindex"></div>
              <div class="packnumber">
                <span>商品</span>
              </div>
              <div class="packweight">
                <span>件數</span>
              </div>
              <div class="packvalue">
                <span>物品單價</span>
              </div>
            </div>
          </div>
          <div class="listpack" v-for="(item, index) in goodlist" :key="index"
               style="margin-bottom: 0;max-height: 3rem;overflow-y: scroll">
            <div class="packindex">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="packnumber">
              <span>{{ item.name }}</span>
            </div>
            <div class="packweight">
              <span>{{ item.num }}</span>
            </div>
            <div class="packvalue">
              ¥
              <md-amount :value="item.price" has-separator></md-amount>
            </div>
          </div>
        </div>
      </div>
    </md-popup>
    <!-- 弹出公告 -->
    <md-landscape v-model="showCustomTransition" transition="md-bounce" :mask-closable="true">
      <div class="eJectModal">
        <div class="title">
          附加费
        </div>
        <div class="content">
          <div class="packcontilist">
            <div class="listmkck">
              <div class="listpack">
                <div class="packnumber">
                  <span>包裹單號</span>
                </div>
                <div class="packvalue">
                  <span>附加费</span>
                </div>
              </div>
              <div class="listpack bordernone" v-for="(item, index) in par.parcelList" :key="index">
                <div class="packnumber">
                  <span>{{ item.expressNumber }}</span>
                </div>
                <div class="packvalue maxlengt" v-if="item.surchargesMemo">
                  <span>{{ item.surchargesMemo }}:</span>
                  <md-amount :value="item.surchargesMoney" has-separator></md-amount>
                  CNY
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </md-landscape>
    <md-popup v-model="isSelectorShow" position="bottom">
      <md-popup-title-bar title="優惠券" ok-text="确认" cancel-text="不使用" large-radius @confirm="onSelectorChoose"
                          @cancel="hidePopUp"></md-popup-title-bar>
      <div class="coupcontainer" v-if="allcoupons.length > 0">
        <div v-for="(item, index) in allcoupons" :key="index" :class="
          item.thresholdPrice <= par.freight ? 'coupitem' : 'coupitem nocolor'
        " @click="getcoupindex(index)">
          <div class="coupitemleft">
            <p v-if="item.type != 2" style="font-size: 0.43rem; color: orangered">
              ¥
              <md-amount :value="item.price" :precision="2"></md-amount>
            </p>
            <span v-if="item.type == 2" style="font-size: 0.43rem; color: orangered">{{ item.price }}折</span>
            <p v-if="item.thresholdPrice > 0" style="color: rgba(183, 183, 183, 1); font-size: 0.26rem">
              滿
              <md-amount :value="item.thresholdPrice" :precision="2"></md-amount>
              可用
            </p>
            <p v-if="item.thresholdPrice == 0" style="color: rgba(183, 183, 183, 1); font-size: 0.26rem">
              無門檻使用
            </p>
          </div>
          <div class="coupitemright">
            <span style="font-size: 0.38rem">{{ item.name }}</span>
            <span style="color: rgba(183, 183, 183, 1); font-size: 0.24rem">{{
                item.beginTime | dateformat("YYYY-MM-DD")
              }}-{{
                item.endTime | dateformat("YYYY-MM-DD")
              }}</span>
          </div>
          <img src="@/assets/image/chose.jpg" alt="" class="messageimg" v-if="coupcde == index"/>
        </div>
      </div>
    </md-popup>
    <md-image-viewer
      v-model="isViewerShow"
      :list="imageUrl"
      :has-dots="true"
      :initial-index="viewerIndex">
    </md-image-viewer>
  </div>
</template>

<script>
import {
  Button,
  Popup,
  Field,
  Tag,
  FieldItem,
  ImageViewer,
  Icon,
  InputItem,
  PopupTitleBar,
  CellItem,
  Stepper,
  Toast,

  Amount,
  Landscape,
  Dialog, Switch,
} from 'mand-mobile';

export default {
  name: 'packdetail',
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [ImageViewer.name]: ImageViewer,
    [PopupTitleBar.name]: PopupTitleBar,
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Icon.name]: Icon,
    [Landscape.name]: Landscape,
    [Tag.name]: Tag,
    [Amount.name]: Amount,
    [Switch.name]: Switch,
    [FieldItem.name]: FieldItem,
    [Stepper.name]: Stepper,
    // eslint-disable-next-line vue/no-unused-components
  },
  data() {
    return {
      showpup: {},
      isfrsh: true,
      parcelList: [],
      addshow: false,
      coupcde: null,
      isViewerShow: false,
      goodlist: [],
      viewerIndex: 0,
      imageUrl: [],
      coupprice: 0,
      showCustomTransition: false,
      loading: false,
      par: {},
      creditStatus: false,
      creditPrice: 0,
      allTotalprice: 0,
      counp: '',
      isSelectorShow: false,
      declarantList: [],
      allcoupons: [],
    };
  },
  beforeRouteLeave(to, form, next) {
    this.isfrsh = true;
    this.addshow = false;
    next();
  },
  activated() {
    Toast.loading('加載中...');
    this.getdetail();
  },
  methods: {
    showckal(type) {
      this.$set(this.showpup, type, true);
    },
    changeAllPrice() {

      this.getallprice();
    },
    showViewer(index) {
      this.viewerIndex = index
      this.isViewerShow = true
    },
    getallprice() {

      // allTotalprice
      //this.coupprice
      let allprice = 0
      let creditPrece = 0
      let freight = 0
      if (this.creditStatus) {
        creditPrece = this.creditPrice
      } else {
        creditPrece = 0
      }
      console.log('creditPrece', creditPrece)
      console.log('creditPrece', creditPrece)
      let addprec = this.getsum('money', this.par.afootInfo.servicecharge)
      freight = this.par.freight - creditPrece - this.coupprice
      if (freight < 0) {
        freight = 0
      }
      console.log('freight', freight)
      console.log('addprec', addprec)
      allprice = addprec + freight
      this.allTotalprice = allprice.toFixed(2)
      this.isSelectorShow = false

    },
    getcoupindex(index) {
      if (this.allcoupons[index].thresholdPrice <= this.par.freight) {
        this.coupcde = index;
      }
    },
    getcouefrt() {
      if (this.allcoupons.length > 0) {
        this.isSelectorShow = true;
      } else {
        Toast.failed('暫無可使用的優惠券');
      }
    },
    hidePopUp() {
      this.coupid = '';
      this.coupcde = null;
      var price = 0;
      this.counp = '有優惠券可使用';
      this.coupprice = price;
      this.getCreditPrice();

    },
    submit() {
      Dialog.confirm({
        content: '是否去支付？',
        confirmText: '確定',
        onConfirm: () => {
          this.$router.push({
            name: 'Pay',
            query: {
              id: this.$route.query.id,
              price: this.par.totalPrice.toFixed(2),
            },
          });
        },
      });
    },
    submitPrice() {
      const param = {
        creditStatus: this.creditStatus,
        couponsId: this.coupid != '0' ? this.coupid : '',
        orderId: this.$route.query.id,
      };
      console.log(param)
      this.http.APIASK(this.ports.submitRearOrder, 'post', param)
        .then((res) => {
          this.$router.push({
            name: 'Pay',
            query: {
              id: res.id,
              price: this.allTotalprice,
            },
          });
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    copy(name) {
      const url = name;
      const oInput = document.createElement('input');
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand('Copy'); // 执行浏览器复制命令
      oInput.remove();
      Toast.succeed('複製成功');
    },
    flatarr(arr) {
      while (arr.some((t) => Array.isArray(t))) {
        arr = [].concat.apply([], arr);
      }
      return arr;
    },
    getsum(key, arr) {
      // let arr=this.par.afootInfo.packages
      var s = 0;
      for (var i = arr.length - 1; i >= 0; i--) {
        var num = arr[i][key]
        if (!num) {
          num = 0
        }
        s += parseFloat(num);
      }
      return s;

    },

    getCreditPrice() {

      const param = {
        countryId: this.par.countryId,
        couponId: (this.coupid !== 0 && this.coupid != '0') ? this.coupid : null,
        totalPrice: this.par.freight,
      };
      this.http
        .APIASK(this.ports.getCreditPrice, 'get', param)
        .then((res) => {

          this.creditStatus = res.creditStatus;
          this.creditPrice = res.creditPrice;
          this.creditValue = res.creditValue;
          this.changeAllPrice();
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    onSelectorChoose() {
      var finitem = this.allcoupons[this.coupcde];
      if (finitem.thresholdPrice > this.par.freight) {
        return;
      }

      this.coupid = finitem.id;
      var price = 0;
      if (finitem.type == 2) {
        price =
          this.par.freight -
          (this.par.freight * finitem.price) / 10;
      } else {
        price = finitem.price;
      }
      this.counp =
        this.allcoupons[this.coupcde].name +
        '(' +
        price.toFixed(2) +
        'CNY' +
        ')';
      this.coupprice = price;
      console.log('this.counp', this.counp)

      // 选择优惠券后获取积分抵扣
      this.getCreditPrice();
    },
    getcoupisl() {
      const par = {
        orderId: this.$route.query.id,
      };
      this.http
        .APIASK(this.ports.getUserCouponValidByOrderId, 'get', par)
        .then((res) => {
          var resutl = res.filter((item) =>
            item.countryId == this.par.countryId || !item.countryId
          );
          console.log('resutl', resutl)
          this.allcoupons = resutl;
          this.choione(resutl);
        })
        .catch((err) => {
          Toast.hide();

        });
    },
    choione(resutl) {
      if (resutl.length > 0) {
        const findvake = resutl.filter((val) => {
          return val.thresholdPrice <= this.par.freight;
        });
        console.log('有可使用的券resutl', findvake);
        if (findvake.length > 0) {
          console.log('12');
          this.coupcde = 0;
          console.log('有可使用的券');
          this.onSelectorChoose();
        } else {
          console.log('122');
          this.coupcde = null;
          this.counp = '暫無優惠券可使用';
          this.onSelectorChoose();
        }
      } else {
        console.log('2344');
        this.coupcde = null;
        this.counp = '暫無優惠券可使用';
        this.getallprice();
      }
    },
    getdetail() {
      const par = {
        id: this.$route.query.id,
      };
      this.http
        .APIASK(this.ports.orderdetail, 'get', par)
        .then((res) => {
          this.par = res;
          this.par.parcelList
            ? (this.parcelList = this.par.parcelList)
            : (this.parcelList = []);
          let num = [];
          if (this.parcelList.length > 0) {
            this.parcelList.some((item) => {
              num.push(item.list);
            });
          }
          this.goodlist = this.flatarr(num);
          this.declarantList = res.declareVoList ? res.declareVoList : [];
          Toast.hide();
          this.addshow = true;
          this.imageUrl = []
          if (res.afootInfo && res.afootInfo.imageUrl) {
            res.afootInfo.imageUrl.map(val => {
              this.imageUrl.push(val.image)
            })

          } else {
            this.imageUrl = []
          }
          console.log(' this.imageUrl', this.imageUrl)
          if (this.par.status === 11) {
            this.getcoupisl()
          }
        })
        .catch((err) => {
          Toast.hide();
          this.addshow = false;
        });
    },
  },
};
</script>

<style lang="less">
.pagetdetial {
  .noth {
    padding: 0 0.4rem;

    .md-cell-item-content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .md-cell-item-brief {
        font-size: 0.32rem;
        color: #e51c23;
      }
    }
  }

  .bootomsubmit {
    width: 100%;
    height: 1rem;
    position: fixed;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 999;

    p {
      font-size: 0.38rem;
      color: #e51c23;
      padding-left: 0.32rem;

      span {
        font-size: 0.3rem;
      }
    }
  }

  .allshow {
    width: 100%;
    height: 1.5rem;
    background-color: white;
    font-size: 0.32rem;

    p {
      padding-left: 5%;
      text-align: left;
    }
  }

  .other.md-field {
    padding: 0 0.4rem;

    img {
      width: 0.5rem;
    }
  }

  .md-cell-item-title {
    text-align: left;
  }

  .md-cell-item-right {
    text-align: left;
    width: 70%;
    display: flex;
    justify-content: flex-start !important;
    align-items: center !important;
  }

  .md-image-viewer .viewer-item-wrap .item {
    width: 84%;
    display: inline-block;
    position: absolute;
    top: 46%;
    left: 8%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .tip {
    margin-left: 0.55rem;
    font-size: 0.24rem;
    color: #e51c23;
  }

  .md-cell-item-body {
    padding: 0;
    min-height: 0.8rem;
  }

  .md-cell-item-body:before {
    content: '';
    position: absolute;
    z-index: 2;
    -webkit-transform: scaleY(0.5) translateY(100%);
    transform: scaleY(0.5) translateY(100%);
    bottom: 0;
    left: 0;
    right: auto;
    top: auto;
    width: 100%;
    border-bottom: 0.02rem solid #e2e4ea;
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
  }

  .address {
    .md-cell-item-brief {
      text-align: left;
    }
  }

  .packtitle {
    width: 90%;
    margin-left: 5%;
    height: 0.6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.3rem;
  }

  .packcontilist {
    width: 100%;
    background-color: white;
    padding: 0.2rem 0;
  }

  .listmkck {
    width: 100%;
  }

  .listpack {
    margin-top: 0.2rem;
    width: 100%;
    display: flex;
    font-size: 0.26rem;
    margin-bottom: 0.2rem;

    .packindex {
      width: 10%;
      text-align: center;
    }

    .packnumber {
      width: 35%;
      text-align: left;
    }

    .packtype {
      width: 10%;
      text-align: left;
    }

    .packweight {
      width: 20%;
      text-align: center;
    }

    .packvalue {
      width: 28%;
      text-align: left;
    }
  }

  .packlist {
    width: 100%;
    background-color: white;
    padding: 0.2rem 0;

    .borerconew {
      width: 96%;
      margin-left: 2%;
      border: 1px solid #f0f0f2;
      border-radius: 0.2rem;
    }
  }

  .holder {
    display: flex;
    align-items: center;
  }

  .declared_container {
    background: white;
    padding: 0.2rem;
    flex-direction: column;
    display: flex;
    align-items: center;
    font-size: 0.26rem;

    table {
      width: 100%;

      .header {
        color: #888888;
        line-height: 0.4rem;

        th:first-child {
          width: 15%;
        }

        th:last-child {
          width: 10%;
        }
      }

      .content {
        line-height: 0.6rem;
      }
    }

    .title {
      font-size: 0.26rem;
      text-align: left;
      font-weight: bold;
      margin: 0.2em 0 0.5em 0;
    }
  }
}

.bordernone {
  border-bottom: 1px solid #f2f2f2;
  padding: 0.2rem 0;
}

.uwne {
  width: 90%;
}

.maxlengt {
  width: 55% !important;
}

.coupcontainer {
  width: 100%;
  max-height: 7rem;
  overflow-y: scroll;
  background-color: white;
  padding: 0.2rem 0;

  .coupitem {
    width: 94%;
    height: 1.5rem;
    margin-left: 3%;
    border: 1px solid #f0f0f2;
    box-shadow: 2px 2px 7px 2px rgba(207, 207, 207, 0.5);
    margin-top: 0.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .coupitemleft {
      width: 40%;
      display: flex;
      height: 55%;
      flex-direction: column;
      justify-content: space-around;
      padding-right: 0.2rem;
    }

    .coupitemright {
      width: 60%;
      display: flex;
      height: 55%;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-around;
    }

    .messageimg {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .nocolor {
    background-color: #f0f0f2;
  }

}

.noright {
  .md-cell-item-content {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .md-cell-item-brief {
      width: 80%;
      margin-top: 0;
      font-size: 0.28rem;
    }

  }

  .md-cell-item-right {
    width: 0.8rem !important;
  }
}
</style>
